export default __webpack_public_path__ + "static/logo_citius_tagline_vertical_white-19c67d0ef3b4bacde65d74db567baa2e.svg";